import request from "@/hooks/useRequest";

// kyc个人协议签署
export const personalSignAgreemnet = (body) => {
  return request("/web-wallet/api/v1/kyc/personal/agreement/sign", { body });
};

//获取kyc进程信息
export const getProcessInfoApi = (params) => {
  return request("/web-wallet/api/v1/kyc/process-info", { params });
};

//获取 Kyc协议
export const getKycSignAgreemnetApi = () => {
  return request("/web-wallet/api/v1/kyc/personal/agreement");
};
